import React, { createContext, useContext, useMemo, useState } from "react";

// The old Firestore-backed UserContext orchestrated moods, themes,
// subscription status, offline sync, etc. through a big reducer wired to
// Firestore listeners. experience-backend doesn't have endpoints for any of
// that yet (no user/theme/mood-history persistence), so this is a plain
// local state container: it keeps every consumer's expected shape working,
// but nothing here round-trips to a server. Real backend-backed data (teams,
// team members, causes) lives in TeamContext/CauseContext instead.
/** @type {any} */
const defaultAppStateValue = {
  moods: [],
  setMoods: (..._args) => {},
  selectedDate: null,
  setSelectedDate: (..._args) => {},
  themeId: null,
  setThemeId: (..._args) => {},
  collectionId: null,
  setCollectionId: (..._args) => {},
  themes: [],
  collections: [],
  isSubscribedStripe: false,
  isLoading: false,
  loadingStates: {},
  isOffline: false,
  refreshData: async (..._args) => {},
  refreshTeamMoods: (..._args) => {},
  clearCache: (..._args) => {},
};

const UserContext = createContext(defaultAppStateValue);

export const UserProvider = ({ children }) => {
  const [moods, setMoods] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [themeId, setThemeId] = useState(null);
  const [collectionId, setCollectionId] = useState(null);
  /** @type {any} */
  const initialLoadingStates = {};
  const [loadingStates] = useState(initialLoadingStates);

  const refreshData = async (..._args) => {
    // No-op: there is no backend endpoint yet to refresh user/theme/mood
    // data from. Kept so existing call sites don't need to change.
  };

  const refreshTeamMoods = (..._args) => {};
  const clearCache = (..._args) => {};

  const value = useMemo(
    () => ({
      moods,
      setMoods,
      selectedDate,
      setSelectedDate,
      themeId,
      setThemeId,
      collectionId,
      setCollectionId,
      themes: [],
      collections: [],
      isSubscribedStripe: false,
      isLoading: false,
      loadingStates,
      isOffline: false,
      refreshData,
      refreshTeamMoods,
      clearCache,
    }),
    [moods, selectedDate, themeId, collectionId, loadingStates]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useAppState = () => useContext(UserContext);
